export default __webpack_public_path__ + "static/media/icon-member.8e841ff9.svg";